module.exports = __webpack_public_path__ + "img/linkedin-active.d2810f3.png";